import { track } from "@wise-emotions/gtm-tracking";
import React, { ReactNode, useEffect } from "react";

interface Props {
  children: ReactNode;
  path: string;
  page_url: string;
  lang: string;
}

const WrapPage = ({ children, path, page_url, lang }: Props) => {
  useEffect(() => {
    track({
      event: "language_status",
      language_action: "default",
      language_used: lang,
    });
    track({ event: "virtual_page_view", page_url, page_language: lang });
  }, [path, page_url, lang]);
  return children;
};

export default WrapPage;
